import React from 'react';
import Contact from '../components/Contact';

const ContactPage = () => {
    return (
        <div className="contact-page reveal-fade">
            <Contact />
        </div>
    );
};

export default ContactPage;
